function f(r, n) {
  if (!r)
    return !1;
  if (r.contains)
    return r.contains(n);
  for (var t = n; t; ) {
    if (t === r)
      return !0;
    t = t.parentNode;
  }
  return !1;
}
export {
  f as default
};
//# sourceMappingURL=contains.mjs.map
